import React from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useIntl } from 'react-intl';

import { membershipTypeMessages } from 'src/features/membershipType/utils/messages';
import { MembershipType } from 'src/features/membershipType/types';
import ConfirmationModal from 'src/registry/components/blocks/ConfirmationModal';
import { DataTableNewEntryProps } from 'src/registry/components/table';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface DeleteMembershipTemplateProps<TData> extends DataTableNewEntryProps<TData> {
    selectedTemplate?: MembershipType;
    deleteTemplate: ({ parkingId, membershipTypeId }: { parkingId: string; membershipTypeId: string }) => void;
    children?: React.ReactNode;
}

function DeleteMembershipType<TData>({
    selectedTemplate,
    deleteTemplate,
    children,
}: DeleteMembershipTemplateProps<TData>) {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { locale } = useIntl();
    const { parkingId } = useParking();
    if (!selectedTemplate) return null;

    return (
        <ConfirmationModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            dialogDetails={{
                title: { ...membershipTypeMessages.deleteTemplate },
                subTitle: {
                    ...membershipTypeMessages.deleteTemplateSubtitle,
                    values: {
                        entry: selectedTemplate.translations?.find((temp) => temp.language === locale)?.name ?? '-',
                    },
                },
                icon: ICON_MAP.DELETE as IconProp,
                confirmationMessage: {
                    ...membershipTypeMessages.confirmDeleteTemplate,
                    values: {
                        entry: selectedTemplate.translations?.find((temp) => temp.language === locale)?.name ?? '-',
                    },
                },
            }}
            callbackButton={{
                variant: 'destructiveLight',
                buttonTitle: generalMessages.delete,
                callbackFn: () => {
                    if (selectedTemplate) {
                        deleteTemplate({ parkingId, membershipTypeId: selectedTemplate.id || '' });
                        return setIsModalOpen(false);
                    }
                },
            }}
        >
            {children}
        </ConfirmationModal>
    );
}

export default DeleteMembershipType;
